import { DebugTimeMachine } from '@/components';

export function DebugTimelineComponent() {
  return <DebugTimeMachine />;
}
